/* eslint-disable react/no-array-index-key */

/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Overlay from 'react-bootstrap/Overlay';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import TooltipWrap from '../../TooltipWrap';
import { Separator } from '../../_layouts';
import VerticalFlow from '../../_layouts/VerticalFlow';
import DropdownButton from './dropdown/DropdownButton';
import DropdownTitle from './dropdown/DropdownTitle';
import { DropdownComponent, DropdownPopover } from './styles';

const Dropdown = (props) => {
  const { children, id, items, menuTitle } = props;

  const [showMenu, setShowMenu] = useState(false);
  const buttonRef = useRef(null);

  const buttons = items.map((item, index) => {
    const classNames = [
      ...(item.disabled ? ['pointer-events-none'] : []),
      item.className,
    ].join(' ');
    if (item.content === 'separator') {
      return <Separator key={item.key} />;
    }

    const button = (
      <DropdownButton
        key={item.key || `item_${index}`}
        buttonType={item.buttonType || 'secondary'}
        className={classNames}
        data={{
          ...{ test: `dropdown-item-${item.key ? item.key : item.content}` },
          ...item.data,
        }}
        disabled={item.disabled === true}
        href={item.href}
        method={item.method}
        modalRemote={item.modalRemote}
        size={item.size}
        selected={item.selected}
        onClick={(e) => {
          if (item.onClick) {
            item.onClick(e);
          }

          setShowMenu(false);
        }}
      >
        {item.content}
      </DropdownButton>
    );

    return item.tooltipText ? (
      <TooltipWrap key={index} tipText={<span>{item.tooltipText}</span>}>
        <span className='d-inline-block'>{button}</span>
      </TooltipWrap>
    ) : (
      <React.Fragment key={index}>{button}</React.Fragment>
    );
  });

  return (
    <DropdownComponent>
      <div
        id={id}
        onClick={() => setShowMenu(!showMenu)}
        ref={buttonRef}
        className='action-menu'
        aria-hidden='true'
      >
        {children({ isOpen: showMenu })}
      </div>

      <Overlay
        popperConfig={{
          modifiers: {
            name: 'offset',
            options: {
              offset: [0, 4],
            },
          },
        }}
        flip
        onHide={() => setShowMenu(false)}
        placement='bottom-end'
        rootClose
        show={showMenu}
        target={buttonRef.current}
      >
        {(overlayProps) => (
          <DropdownPopover {...overlayProps}>
            <VerticalFlow spacing='0rem'>
              {menuTitle && <DropdownTitle>{menuTitle}</DropdownTitle>}
              {buttons.map((button) => button)}
            </VerticalFlow>
          </DropdownPopover>
        )}
      </Overlay>
    </DropdownComponent>
  );
};

Dropdown.defaultProps = {
  items: [],
  menuTitle: null,
  id: null,
};

Dropdown.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  menuTitle: PropTypes.string,
  children: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node,
      icon: PropTypes.string,
      href: PropTypes.string,
      onClick: PropTypes.func,
      remote: PropTypes.bool,
      newWindow: PropTypes.bool,
      method: PropTypes.string,
      data: PropTypes.object,
      cssClass: PropTypes.string,
      tooltipText: PropTypes.string,
    })
  ),
};

function DropdownFallback() {
  return <span />;
}

export default exportWithBoundary(Dropdown, DropdownFallback);
